<template>
  <div class="main-graph-window">
    <div class="menu-wrapper">
      <ul class="sub-menu-dropup">
        <li
          class="dropdown-item btn btn-block btn-light-gray"
          v-for="tab in paginate(graphTabs)[tabPaginate]"
          :key="tab"
          @click="TabClick(tab)"
          @mouseenter="hoveringTab = tab.alias"
          @mouseleave="hoveringTab = false"
          :class="{
            active: selectedTab === tab.alias.toUpperCase(),
            'cal-match':
              selectedCalendarType.alias === mainCalendarSection &&
              selectedTab === tab.alias
          }"
        >
          <span
            class="dropdown-item-left"
            :class="{
              longTitleFontSize: tab.name.length > 6
            }"
            >{{ tab.name }}</span
          >
          <span class="dropdown-item-right" v-if="tab.hasOwnProperty('subMenu')"
            ><i class="fas fa-caret-right"></i
          ></span>
          <ul
            class="sub-menu-main"
            v-if="
              tab.hasOwnProperty('subMenu') &&
                hoveringTab === tab.alias &&
                selectedTab === tab.alias
            "
          >
            <li
              class="dropdown-item btn btn-block btn-light-gray"
              v-for="subTab in tab.subMenu"
              :key="subTab.id"
              @click.stop="clickSubTab(subTab)"
              :class="{
                active: selectedSubTab === subTab.alias
              }"
            >
              <span class="dropdown-item-left sub">{{ subTab.name }}</span>
            </li>
          </ul>
        </li>
      </ul>
      <div class="arrow-down" v-if="graphTabs.length > tabsLength">
        <i
          :class="{
            disabled_scroll: paginate(graphTabs)[tabPaginate + 1] === undefined
          }"
          class="fas fa-angle-down"
          @click="tabPaginate++"
        ></i>
        <i
          :class="{
            disabled_scroll: paginate(graphTabs)[tabPaginate - 1] === undefined
          }"
          class="fas fa-angle-up"
          @click="tabPaginate--"
        ></i>
      </div>
    </div>
    <div class="chart-section">
      <div class="deposit-chart" id="main-chart-countries"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import moment from "moment";

const UsersBar = {
  type: "bar",
  options: {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 15,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },
    // legend: {
    //     position: "top",
    //     align: "end",
    //     labels: {
    //         boxWidth: 20,
    //         fontSize: 10,
    //         display: false
    //     },
    //     onHover: function(e) {
    //         e.target.style.cursor = 'pointer';
    //     }
    // },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};

export default {
  name: "CountriesCharts.component",
  computed: {
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "multiSelectChartData",
      "selectedCalendarType"
    ]),
    ...mapGetters("clients", ["getMultiSelectChartData"])
  },
  mixins: [UsersPermissionCheck],
  props: {
    mainData: {
      required: true,
      type: Object
    },
    mainSector: {
      required: true,
      type: String
    },
    tabs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      UsersBar: UsersBar,
      requestsForTabs: {},
      statusChartTab: null,
      allData: {},
      selectedTab: "",

      tabPaginate: 0,
      tabsLength: 8,
      ext_tabs: [],
      graphTabs: [],
      globalDateRange: "TODAY",
      mainCalendarSection: "REG",
      hoveringTab: false,
      chartData: []
    };
  },
  created() {
    this.graphTabs = this.tabs;
    this.selectedTab = this.graphTabs[0].alias.toUpperCase();
  },
  watch: {
    multiSelectChartData: {
      handler() {
        this.initialChartData(this.getMultiSelectChartData);
      },
      deep: true
    }
  },

  methods: {
    async initialChartData(data) {
      if (this.mainSector === data.selectedSector) {
        let element = document.getElementsByClassName(
          "dropdown-item btn btn-block btn-light-gray active"
        );
        $(element).removeClass("loading");
        if (data.fromChart) {
          return;
        }
        let tab = this.ext_tabs.filter(tab => {
          return tab.alias === this.selectedTab;
        });
        if (tab.length > 0) {
          await this.fetchExternalGraphs(tab[0]);
          return;
        }
        // this.$store.commit("clients/setSelectedCalendarType", {
        //   alias: this.mainCalendarSection,
        //   preset: null
        // });
        this.mainSector = data.selectedSector;
        this.allData = data;
        this.chartData = data.data[this.mainSector].data;
        this.selectedTab = data.data[this.mainSector].selectedTab.toUpperCase();
        let lineChartStatus = `main-chart-countries`;
        if (this.statusChartTab) {
          this.statusChartTab.destroy();
        }
        if (!this.chartData.hasOwnProperty(this.mainSector)) {
          this.createChart(lineChartStatus, this.chartData);
        }
      }
    },
    async TabClick(tab) {
      if (
        (!tab.hasOwnProperty("ex") && !tab.ex) ||
        (tab.hasOwnProperty("ex") &&
          tab.hasOwnProperty("combine") &&
          tab.combine)
      ) {
        if (tab.hasOwnProperty("subMenu")) {
          this.selectedSubTab = tab.subMenu[0].alias;
        }
        // if (this.selectedTab !== tab.alias) {
        //   this.$store.commit("clients/setSelectedCalendarType", {
        //     alias: this.mainCalendarSection,
        //     preset: null
        //   });
        // }
        let element = document.getElementsByClassName(
          "dropdown-item btn btn-block btn-light-gray active"
        );
        $(element).addClass("loading");
        this.selectedTab = tab.alias;
        let data = Object.assign({}, this.allData);
        data.selectedTab = tab.alias;
        data.fromChart = true;
        this.$store.commit("clients/setMultiSelectChartData", [
          data,
          this.mainSector
        ]);
      }
      if (tab.hasOwnProperty("ex") && tab.ex) {
        this.selectedTab = tab.alias;
        if (tab.hasOwnProperty("subMenu")) {
          this.selectedSubTab = tab.subMenu[0].alias;
        }
        await this.fetchExternalGraphs(tab);
      }
    },
    clickSubTab(subTab) {
      this.selectedSubTab = subTab.alias;

      //functions of sub tabs
    },

    namesFormatter(name, numLet = 3) {
      let first_name = name.split(" ")[0].substring(0, numLet);
      let second_name = "";
      name.split(" ").length > 1
        ? (second_name = name
            .split(" ")[1]
            .substring(0, 1)
            .toUpperCase())
        : (second_name = "");
      let fullName = first_name + " " + second_name;
      return fullName;
    },
    clickOnMainTab(alias) {
      this.$store.commit("clients/setMainGraphTabData", alias);
    },

    async fetchExternalGraphs(subSector) {
      if (this.statusChartTab) {
        this.statusChartTab.destroy();
      }
      let tab = subSector.alias;
      let element = document.getElementsByClassName(
        "dropdown-item btn btn-block btn-light-gray active"
      );
      $(element).addClass("loading");
      this.depUsersStatsToday = [];
      this.requestsForTabs[tab] = true;
      if (!this.showReset) {
        this.resetMainFilters();
      } else {
        this.mainFilters = this.generalQueryObject;
      }

      //functions for ext tabs

      this.requestsForTabs[tab] = false;
      $(element).removeClass("loading");
    },

    createChart(canvas, chartData) {
      let tempData = [];
      chartData.map(item => {
        tempData.push({
          name: item.title,
          size: item.count[0] + 5,
          value: item.count[0]
        });
      });
      //let counter = naCountriesData.reduce((a, b) => a + b)
      let dataToChart = [{ children: tempData }];
      let chart = anychart.treeMap(dataToChart, "as-tree");
      $("#" + canvas).html("");
      chart.container(canvas);
      let customColorScale = anychart.scales.linearColor();
      customColorScale.colors(["#00acff", "#016e9f"]);
      chart.maxDepth(2);
      chart.headers(false);
      chart.colorScale(customColorScale);
      chart.padding(0);
      chart.draw();

      let credits = document.getElementsByClassName("anychart-credits");
      $(credits).hide();
    },

    createWorldMapChart(states, chartId, colors) {
      let canvasChartId = chartId;
      let chartColors = colors;

      if (canvasChartId === "bar-chart-today-reg-by-country") {
        this.showCounter = true;
        this.countryCounter = true;
        if (states.length > 0) {
          this.showCounter = true;
          this.counterData = [
            ...this.counterData,
            {
              tag: "Countries",
              count: states.reduce((a, b) => a + b.value, 0)
            }
          ];
        }
      }

      $("#" + canvasChartId).html("");

      let map = anychart.map();
      map.container(canvasChartId);

      // create data set
      let dataSet = anychart.data.set(states);

      // create choropleth series
      let series = map.choropleth(dataSet);

      // set geoIdField to 'id', this field contains in geo data meta properties
      series.geoIdField("id");

      // set map color settings
      series.colorScale(anychart.scales.linearColor(chartColors));
      series.hovered().fill("#addd8e");

      map.geoData(anychart.maps.world);

      //initiate map drawing
      map.draw();

      let zoomController = anychart.ui.zoom();
      zoomController.render(map);

      map.zoom(1);
      let clicked = true;
      // map.listen("click", function(evt) {
      //     if (clicked) {
      //         map.zoomTo(3, evt.clientX, evt.clientY);
      //     }
      //     else {
      //         map.zoomTo(1, evt.clientX, evt.clientY);
      //     }
      //     clicked = !clicked;
      // });

      let zoomDiv = document.getElementsByClassName("anychart-zoom");
      $(zoomDiv).css("position", "absolute");
      $(zoomDiv).css("z-index", 10000);
      $(zoomDiv).css("top", "20px");

      let fitAll = document.getElementsByClassName(
        "anychart-button anychart-zoom-zoomFitAll"
      );
      $(fitAll).html('<i class="fas fa-vector-square"></i>');

      let zoomIn = document.getElementsByClassName(
        "anychart-button anychart-zoom-zoomIn"
      );
      $(zoomIn).html('<i class="fas fa-plus"></i>');

      let zoomOut = document.getElementsByClassName(
        "anychart-button anychart-zoom-zoomOut"
      );
      $(zoomOut).html('<i class="fas fa-minus"></i>');

      let credits = document.getElementsByClassName("anychart-credits");
      $(credits).hide();
    },

    createTreeMapChart(states, chartId, colors) {
      let allData = states;
      let canvasChartId = chartId;
      let chartColors = colors;

      if (
        canvasChartId === "bar-chart-today-reg-by-campaigns" ||
        canvasChartId === "line-chart-as-md-by-campaigns-today"
      ) {
        this.showCounter = true;
        this.campaignsCounter = true;
        if (allData[0].children.length > 0) {
          this.showCounter = true;
          this.counterData = [
            ...this.counterData,
            {
              tag: "Campaigns",
              count: allData[0].children.reduce((a, b) => a + b.value, 0)
            }
          ];
        }
      }
      if (
        canvasChartId === "bar-chart-today-reg-by-country" ||
        canvasChartId === "line-chart-as-md-by-countries-today"
      ) {
        this.showCounter = true;
        this.countryCounter = true;
        if (allData[0].children.length > 0) {
          this.showCounter = true;
          this.counterData = [
            ...this.counterData,
            {
              tag: "Countries",
              count: allData[0].children.reduce((a, b) => a + b.value, 0)
            }
          ];
        }
      }

      let chart = anychart.treeMap(allData, "as-tree");
      $("#" + canvasChartId).html("");
      chart.container(canvasChartId);
      let customColorScale = anychart.scales.linearColor();
      customColorScale.colors(chartColors);
      chart.maxDepth(2);
      chart.headers(false);
      chart.colorScale(customColorScale);
      chart.draw();

      let credits = document.getElementsByClassName("anychart-credits");
      $(credits).hide();
    },

    paginate(stats) {
      let pageSize = this.tabsLength;

      let inputArray = stats;

      let result = inputArray.reduce((resultArray, item, index) => {
        const pageIndex = Math.floor(index / pageSize);

        if (!resultArray[pageIndex]) {
          resultArray[pageIndex] = []; // start a new page
        }

        resultArray[pageIndex].push(item);

        return resultArray;
      }, []);

      return result;
    },
    resetMainFilters() {
      this.mainFilters = {
        deposit_at_from: moment(this.defaultPresets().start).format(
          "YYYY-MM-DD"
        ),
        deposit_at_to: moment(this.defaultPresets().end).format("YYYY-MM-DD"),
        special_req: true
      };
    }
  }
};
</script>

<style scoped>
li {
  text-transform: uppercase;
}
.main-graph-window {
  width: 100%;
  min-height: 200px;
  background-color: #fff;
  padding-top: 5px;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
}

.dropdown-item {
  height: 20px;
  min-height: 8%;
  padding: 1px 0px;
  margin: 0px;
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
  border-radius: 0px 5px 5px 0px;
  //margin-bottom: 1px;
  background-color: white;
  border: 1px solid #e5e4e4;
  position: relative;
}
.dropdown-item:focus {
  outline: none;
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}
.dropdown-item.cal-match {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.dropdown-toggle .toggle-left-side {
  /*margin-right: 10px;*/
  margin-right: 36px;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 95px;
  border-radius: 0px;
  padding: 0px;
}

.dropdown-item-left {
  margin-left: 10px;
  /*float: left;*/
  flex: 1;
  font-weight: 500;
}
.dropdown-item-right {
  flex: 1;
}
.chart-section {
  flex: 2;
  width: 92%;
  min-height: 100%;
  max-height: 200px;
  display: flex;
}
.deposit-chart {
  width: 100%;
  min-height: 100%;
}
.longTitleFontSize {
  font-size: 11px;
}
li.active {
  background-color: #00acff;
  color: #fff;
}
.sized_chart {
  max-width: 74%;
  position: relative;
}
.trans-dep-chart {
  position: relative;
  max-width: 13%;
  min-width: 13%;
  max-height: 100%;
  margin-left: 3px;
}
.dep-goal-chart {
  position: relative;
  max-width: 9%;
  min-width: 9%;
  max-height: 100%;
  margin-left: 3px;
}

.sub-menu-main {
  left: 55px;
  top: -1px;
  position: absolute;
  display: flex;
  max-height: 20px;
}
.sub-menu-main li {
  background-color: #efefef;
  color: #0a0a0a;
  cursor: pointer;
  transform: none !important;
  max-height: 20px;
  margin-left: 1px;
  border-radius: 5px;
}
.sub-menu-main li:hover {
  background-color: #dedede;
}
.sub-menu-main li.active {
  background-color: #c12fff;
  color: #fff;
}

.dropdown-item-left.sub {
  margin-left: unset;
  width: 50px;
  text-align: center;
}
li.loading {
  background: linear-gradient(-45deg, #00acff, #0b506e, #00acff, #0b506e);
  background-size: 500% 500%;
  animation: gradient 3s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 0%;
  }

  100% {
    background-position: 100% 50%;
  }
}

.arrow-down {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffa400;
  font-size: 29px;
  cursor: pointer;
}
.disabled_scroll {
  display: none;
}
</style>
